import { ColumnCenter, Row, RowCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import { ReactComponent as ArrowLeftSvg } from 'assets/svgs/arrow_left.svg'
import { ReactComponent as ArrowRight2Svg } from 'assets/svgs/arrow_right_2.svg'
import { ReactComponent as BalanceSvg } from 'assets/svgs/balance.svg'
import { Chain, useAccount, useBalance, useDisconnect, useNetwork, useSwitchNetwork } from "wagmi"
import { getIconUrl, shortStr } from "utils"
import { getWalletLogo } from "utils/walletManage"
import { useCallback, useEffect, useState } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import { removeStore, setStore } from "utils/store"
import { WagmiChainType } from "types/baseType"
import CImage from "components/CImage"

interface Props {
    disconnectChange: () => void
}

const EvmDetailCom = ({disconnectChange} : Props) => {
    const { connector, address } = useAccount()
    const { disconnect } = useDisconnect()
    const { data } = useBalance({
        address: address
    })

    const fnDisconnect = useCallback(() => {
        try {
            disconnect()
            disconnectChange()
            setStore('chainge.curWallet', '')
        } catch(error) {
            
        }
    }, [disconnect, disconnectChange])

    const [isCopy, setIsCopy] = useState(false);
    useEffect(() => {
      if (isCopy) {
        setTimeout(() => {
          setIsCopy(false);
        }, 2000);
      }
    }, [isCopy]);

    // 获取当前链
    const [curChain, setCurChain] = useState<Chain|null>()
    const {chain} = useNetwork()
    const getCurChain = useCallback(async () => {
        if(!chain) return
        const chainList = connector?.chains
        const tempCurChain = chainList?.find((item: Chain) => item.id === chain.id)
        if(tempCurChain) {
            setCurChain(tempCurChain)
        } else {
            setCurChain(null)
        }
    }, [chain, connector?.chains])

    useEffect(() => {
        getCurChain()
    }, [getCurChain])

    // 打开链列表
    const [openChainList, setOpenChainList] = useState(false)
    const fnOpenChainList = () => {
        setOpenChainList(true)
    }

    const fnCloseChainList = () => {
        setOpenChainList(false)
    }
    
    return <>
        {
            openChainList ? <SwitchNetworkCom goBack={fnCloseChainList} chainList={connector?.chains}></SwitchNetworkCom> : <CardWrap>
            <UserAccountInfoWrap>
                <WalletImgWrap src={getWalletLogo(connector?.name || '')}></WalletImgWrap>
                <StyledContainer $mt="10px" $mb="21px" $fontSize="16px" $fontWeight6 $lineHeight="18px" $roobertSemiBold>{connector?.name}</StyledContainer>
                <CopyToClipboard text={address || ''}
                    onCopy={() => setIsCopy(true)}
                >
                    <AddressBarWrap>
                        {
                            shortStr(address || '')
                        }
                        <CopyBtnWrap>{isCopy ? "Copied" : 'Copy'}</CopyBtnWrap>
                    </AddressBarWrap>
                </CopyToClipboard>
                
                <StyledContainer $height="8px"></StyledContainer>

                <ChainItemCom chainInfo={curChain as WagmiChainType} width="170px" onClick={fnOpenChainList}></ChainItemCom>

                <StyledContainer $height="30px"></StyledContainer>
                <Row $justifyContent="space-between" $width="100%">
                    <Row>
                        <BalanceSvgWrap></BalanceSvgWrap>
                        <BalanceTextWrap $ml="6px">Balance</BalanceTextWrap>
                    </Row>
                    <BalanceTextWrap>{(+(data?.formatted || '')).toFixed(4)} {data?.symbol}</BalanceTextWrap>
                </Row>
            </UserAccountInfoWrap>
            <RowCenter>
                <DisconnectBtnWrap onClick={fnDisconnect}>Disconnect</DisconnectBtnWrap>
            </RowCenter>
        </CardWrap>
        }
    </>
}

interface SwitchNetworkProps {
    chainList: Chain[] | undefined
    goBack: () => void
}
const SwitchNetworkCom = ({chainList = [], goBack=() => {}}: SwitchNetworkProps) => {
    const { chain } = useNetwork()
    const { switchNetworkAsync } = useSwitchNetwork()

    const fnSwitchNetwork = useCallback(async (curNetwork: Chain) => {
        try {
          await switchNetworkAsync?.(curNetwork.id);
        } catch (error) {
        }
    }, [switchNetworkAsync])

    return <CardWrap $padding="20px">
        <ArrowLeftSvgWrap onClick={goBack}></ArrowLeftSvgWrap>
        <ChainListWrap>
            {
                chainList.map((item, index) => <ChainItemCom connected={chain?.id === item.id} $mb="10px" onClick={() => fnSwitchNetwork(item)} key={index} chainInfo={item as WagmiChainType} width="100%"></ChainItemCom>)
            }
        </ChainListWrap>
    </CardWrap>
}

interface ChainItemProps {
    width: string
    chainInfo: WagmiChainType | null | undefined
    $mb?: string, onClick: () => void
    connected?: boolean
}
const ChainItemCom = ({width, chainInfo, $mb='0px', onClick = () => {}, connected = false} : ChainItemProps) => {
    return <ChainItemWrap $width={width} $mb={$mb} onClick={onClick}>
        <Row>
            <CImage width="18px" height="18px" mr="8px" src={getIconUrl(chainInfo?.iconIndex, 'chain', 'solid')}></CImage>
            <ChainNameWrap>{chainInfo?.name}</ChainNameWrap>
        </Row>
        {
            connected ? <ConnectedPointWrap></ConnectedPointWrap> : <ArrowRight2SvgWrap></ArrowRight2SvgWrap>
        }
        
    </ChainItemWrap>
}


const CardWrap = styled(StyledContainer)`
    border-radius: 9px;
    background: ${({theme}) => theme.basicWhite};

    box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
`

const UserAccountInfoWrap = styled(ColumnCenter)`
    padding: 20px 17px 8px;
    border-bottom: 1px solid #F2F2F2;
`

const WalletImgWrap = styled.img`
    width: 26px;
    height: 26px;
`

const AddressBarWrap = styled(RowCenter)`
    border-radius: 12px;
    background: #F6F5F4;
    padding: 4px 6px;

    font-size: 12px;
    font-weight: 500;
    line-height: 1;
`

const CopyBtnWrap = styled(RowCenter)`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    font-family: RoobertRegular;
    color: ${({theme}) => theme.basicPurple};
    padding: 3px 6px;
    border-radius: 4px;
    background: ${({theme}) => theme.basicWhite};
    margin-left: 8px;
    cursor: pointer;
`

// 切换链
const ChainItemWrap = styled(Row)`
    padding: 12px;
    border-radius: 12px;
    background: #F6F5F4;

    justify-content:space-between;
    cursor: pointer;

    box-sizing: border-box;
`

const ChainNameWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    font-family: RoobertSemiBold;
`

const ArrowRight2SvgWrap = styled(ArrowRight2Svg)`
    width: 12px;
    height: 12px;
    path {
        fill: ${({theme}) => theme.basicBlack};
    }
`

const BalanceSvgWrap = styled(BalanceSvg)`
`

const BalanceTextWrap = styled(StyledContainer)`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    font-family: RoobertRegular;
    color: #767A7F;
`

const DisconnectBtnWrap = styled(StyledContainer)`

    border-radius: 12px;
    background:  #FFF3F4;
    padding: 9px 8px;

    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    font-family: RoobertSemiBold;

    color: #DF2935;
    cursor: pointer;

    margin: 18px auto 20px;
`

const ArrowLeftSvgWrap = styled(ArrowLeftSvg)`
    width: 12px;
    height: 12px;
    cursor: pointer;
`

const ChainListWrap = styled(StyledContainer)`
    margin-top: 30px;
    height: 220px;
    overflow: auto;
`

const ConnectedPointWrap = styled(StyledContainer)`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({theme}) => theme.basicPurple};
`

export default EvmDetailCom